var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.25em",
    height: "1em",
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.943l11.842 5.876a.867.867 0 00.769 0l11.842-5.875V16.15c0 .88-.353 1.727-.987 2.367a3.688 3.688 0 01-2.421 1.074l-.205.005H3.612c-.922 0-1.81-.337-2.48-.941a3.382 3.382 0 01-1.126-2.31L0 16.15V5.943zM3.612.51h17.229c.922 0 1.81.336 2.48.941a3.382 3.382 0 011.126 2.31l.006.195v.195l-12.227 6.065L0 4.151v-.195c0-.88.353-1.727.987-2.367A3.688 3.688 0 013.407.515L3.613.51h17.229H3.611z",
    fill: "currentColor"
  })));
}

export default SvgMailIcon;